<template>
    <div class="row no-gutters body">
        <div class="col-12">
            <div class="row no-gutters header">
                <div class="col d-flex">
                <div class="col-lg-3 col-md-2 col-sm-1" 
                v-if="(routeName === 'viewjob' || routeName === 'findResumes' || routeName === 'notifications') || (routeName === 'Premium') || !isOnline"
                >
                    <sidemenu class="sidemenu d-block d-sm-block d-md-block d-lg-none"></sidemenu>
                    <div class="ml-5 mt-3 d-none d-lg-block hover" @click="gotoMainPage()">
                        <img src="../assets/Logo.svg" class="MainNewLogo" alt="logo"/>                        
                    </div>                    
                </div>
                <div class="col-lg-3 col-md-2 col-sm-1 d-flex" v-else>
                    <sidemenu class="sidemenu" ></sidemenu>
                </div>
                <div class="col-9 topmenubar">
                    <topmenu></topmenu>
                </div>
                </div>
            </div>
        </div>
        <div class="col-lg-12" v-if="isOnline" >
            <router-view/>
        </div>
        <div class="col-lg-12" v-else>
            <noInternet @close = "retry"></noInternet>
        </div>        
        <Footer class="footer d-block d-sm-block d-md-block d-lg-none" />
    </div>
</template>
<script>
import topmenu from "@/components/TopHeader.vue";
import sidemenu from "@/components/SideMenu.vue";
import Footer from '@/components/Footer';
import noInternet from '@/components/noInternet';
export default {
    components: {
        sidemenu,
        topmenu,
        Footer,
        noInternet
    },
    watch:{

    },
    data(){
        return{
            routeName : null,
            isOnline: navigator.onLine
        }
    },
    created() {
        var that = this;
        setInterval(function(){ 
            that.routeName = that.$store.state.routeName;
            that.isOnline = navigator.onLine;
            // console.log(that.isOnline)
        }, 1000)
    },
    methods : {
        gotoMainPage(){
            if(!this.profileId){
                this.$router.push({
                name : 'welcome'
                })
            }else{
                this.$session.set("selectElement", 'home')
            this.$router.push({
                name : 'MainHome'
                })
            }     
        },
        retry(){
            console.log('enter into retry')
            this.isOnline =  navigator.onLine;
        }
    }
}
</script>
<style scoped>
.header {
    position: fixed;
    width: 100%;
    z-index: 4;
    background: #ffffff;
    border-bottom: 2px solid rgba(219, 219, 219,1);;
}
.sidemenu {
    z-index: 5;
}
.hover{
  cursor: pointer;
}
.footer {
  position: fixed;
  bottom: 0;
  z-index: 5;
}
</style>